import React, { useState } from 'react'
import { DatePicker } from 'antd';
import Select from 'react-select';
import { formatDate, isValidEmail, onlyAlphabets, onlyNumeric } from '../../../components/commonClass/CommonValidation';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../_actions/loader.actions';
import { postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { useLocation } from 'react-router-dom';

const CreateQuery = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [formValue, setFormValue] = useState({
        QueryId: 0,
        TravelCategoryId: 2,
        FirstName: '',
        LastName: '',
        ContactNo: '',
        Email: '',
        OriginCityId: 0,
        OriginCityName: '',
        Adult: 0,
        Child: 0,
        Infant: 0,
        TravelDate: null,
        PackageId: 0,
        PackageName: '',
        QueryDetails: '',
        UserId: 0,
        IsOnline: false
    })

    const [formErrors, setFormErrors] = useState<any>({})


    const decrementCount = (e: any, name: string) => {
        setFormErrors({})
        setFormValue((form: any) => ({ ...form, [name]: form?.[name] - 1 }))
    }

    const incrementCount = (e: any, name: string) => {
        setFormErrors({})
        setFormValue((form: any) => ({ ...form, [name]: form?.[name] + 1 }))
    }

    const val = [{
        label: <>
            <div className='d-flex flex-column'>
                <div className='col-lg-6 col-md-12'>
                    <p className='float-start pt-2'>
                        <i className="fa-solid fa-user me-1"></i>Adult
                    </p>
                    <p className='float-end'>
                        <ul className="d-flex align-items-center p-0 mb-0">
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => decrementCount(e, 'Adult')}
                                    disabled={formValue?.Adult <= 0}
                                    className="btn btn-primary count_btn_search m-0 p-0">
                                    <i className="fa-solid fa-minus" />
                                </button>
                            </li>
                            <li className="mx-2 fs-6"><small className='my-0'>{formValue?.Adult}</small></li>
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => incrementCount(e, 'Adult')}
                                    className="btn btn-primary count_btn_search m-0 p-0">
                                    <i className="fa-solid fa-plus" />
                                </button>
                            </li>
                        </ul>
                    </p>
                </div>
                <div className='col-lg-6 col-md-12'>
                    <p className='float-start pt-2'>
                        <i className="fa-solid fa-children me-1"></i>Child
                    </p>
                    <p className='float-end'>
                        <ul className="d-flex align-items-center p-0 mb-0">
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => decrementCount(e, 'Child')}
                                    disabled={formValue?.Child <= 0}
                                    className="btn btn-primary count_btn_search m-0 p-0"
                                >
                                    <i className="fa-solid fa-minus" />
                                </button>
                            </li>
                            <li className="mx-2 fs-6"><small className='my-0'>{formValue?.Child}</small></li>
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => incrementCount(e, 'Child')}
                                    className="btn btn-primary count_btn_search m-0 p-0"
                                >
                                    <i className="fa-solid fa-plus" />
                                </button>
                            </li>
                        </ul>
                    </p>
                </div>
                <div className='col-lg-6 col-md-12'>
                    <p className='float-start pt-2 pb-0 mb-0'>
                        <i className="fa-solid fa-baby me-1"></i>Infant
                    </p>
                    <p className='float-end pb-0 mb-0'>
                        <ul className="d-flex align-items-center p-0 mb-0">
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => decrementCount(e, 'Infant')}
                                    disabled={formValue?.Infant <= 0}
                                    className="btn btn-primary count_btn_search m-0 p-0"
                                >
                                    <i className="fa-solid fa-minus" />
                                </button>
                            </li>
                            <li className="mx-2 fs-6"><small className='my-0'>{formValue?.Infant}</small></li>
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => incrementCount(e, 'Infant')}
                                    className="btn btn-primary count_btn_search m-0 p-0"
                                >
                                    <i className="fa-solid fa-plus" />
                                </button>
                            </li>
                        </ul>
                    </p>
                </div>
            </div>
        </>, value: 1
    }]


    const handleChange = (name: any, val: any) => {
        setFormErrors({})
        setFormValue((form: any) => ({ ...form, [name]: val }))
    }
    const hendeldropdown = (name: any, val: any) => {
        setFormErrors({})
        if (name === "OriginCityName") {
            setFormValue((form: any) => ({ ...form, OriginCityId: val?.value, OriginCityName: val?.label }))
        }
        if (name === "PackageName") {
            setFormValue((form: any) => ({ ...form, PackageId: val?.value, PackageName: val?.label }))
        }
    }

    const validateData = () => {
        let status: boolean = true;
        const error: any = {}
        if (formValue?.FirstName?.trim()?.length === 0) {
            error.FirstName = "Cannot leave blank, please provide first name.";
            status = false;
        }
        if (formValue?.LastName?.trim()?.length === 0) {
            error.LastName = "Cannot leave blank, please provide last name.";
            status = false;
        }
        if (formValue?.Email?.trim()?.length === 0) {
            error.Email = "Cannot leave blank, please provide email ID.";
            status = false;
        }
        else if (formValue?.Email?.trim()?.length > 0 && !isValidEmail(formValue?.Email)) {
            error.Email = " Please provide valid Email Id.";
            status = false;
        }
        if (formValue?.ContactNo?.trim()?.length === 0) {
            error.ContactNo = "Cannot leave blank, please provide mobile number.";
            status = false;
        }
        else if (formValue?.ContactNo?.trim()?.length < 10) {
            error.ContactNo = "Please provide valid Phone No.";
            status = false;
        }


        if (Object.keys(error).length > 0) {
            let id = Object.keys(error)[0];
            let doc = document.getElementById(id);
            if (doc !== null)
                doc.focus();
        }

        setFormErrors(error);
        return status;
    }


    const clearData = () => {
        setFormValue({
            QueryId: 0,
            TravelCategoryId: 2,
            FirstName: '',
            LastName: '',
            ContactNo: '',
            Email: '',
            OriginCityId: 0,
            OriginCityName: '',
            Adult: 0,
            Child: 0,
            Infant: 0,
            TravelDate: null,
            PackageId: 0,
            PackageName: '',
            QueryDetails: '',
            UserId: 0,
            IsOnline: false
        })
    }

    const handlesavedata = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let user: any = GetLocalStorage();
                formValue.UserId = user?.userMasterID
                const RpsData = await postUsersData("/midoffice/v1/InsertUserTravellerQuery", formValue);
                if (RpsData?.status) {
                    dispatch({ type: 'ALERTINGMESSAGE', message: RpsData?.message })
                    clearData();
                    setFormErrors({})
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: RpsData?.message })
                    dispatch(loaderActions.end());
                }
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }
    }
    const inputdisable = (formValue?.FirstName?.trim()?.length === 0
        || formValue?.LastName?.trim()?.length === 0
        || formValue?.Email?.trim()?.length === 0
        || formValue?.ContactNo?.trim()?.length === 0
    )


    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>{location?.state?.menuTitle}</h2>
            </div>
            <div className="m-2 heading_color">
                <div className='row'>
                    <div className='col-6'>
                        <h4>Create Query</h4>
                    </div>
                    <div className='col-6 text-end'>
                        <button type="button" className="btn btn-primary" disabled={inputdisable} onClick={handlesavedata} id="btnAdd">Create</button>
                    </div>
                </div>
            </div>
            <div className="mt-2">
                <div className='create_query_subheader py-2 mt-2'>
                    <h5 className='mb-0 text-center'>Customer Details</h5>
                </div>
                <div className=' mt-2 p-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='FirstName' className='form-label required'>First Name</label>
                                </div>
                                <div className='col-8'>
                                    <input
                                        id='FirstName'
                                        className='form-control'
                                        name='FirstName'
                                        type='text'
                                        placeholder='First Name'
                                        value={formValue?.FirstName}
                                        maxLength={100}
                                        onChange={(e: any) => handleChange('FirstName', onlyAlphabets(e?.target?.value))}
                                    />
                                    {formErrors?.FirstName && <div className='text-danger text-start fs_14'>{formErrors?.FirstName}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='LastName' className='form-label required'>Last Name</label>
                                </div>
                                <div className='col-8'>
                                    <input
                                        id='LastName'
                                        className='form-control'
                                        name='LastName'
                                        type='text'
                                        placeholder='Last Name'
                                        value={formValue?.LastName}
                                        maxLength={100}
                                        onChange={(e: any) => handleChange('LastName', onlyAlphabets(e?.target?.value))}
                                    />
                                    {formErrors?.LastName && <div className='text-danger text-start fs_14'>{formErrors?.LastName}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='Email' className='form-label required'>Email Id</label>
                                </div>
                                <div className='col-8'>
                                    <input
                                        id='Email'
                                        className='form-control'
                                        name='Email'
                                        type='text'
                                        placeholder='Email Id'
                                        value={formValue?.Email}
                                        maxLength={120}
                                        onChange={(e: any) => handleChange('Email', e?.target?.value)}
                                    />
                                    {formErrors?.Email && <div className='text-danger text-start fs_14'>{formErrors?.Email}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='ContactNo' className='form-label required'>Phone No.</label>
                                </div>
                                <div className='col-8'>
                                    <input
                                        id='ContactNo'
                                        className='form-control'
                                        name='ContactNo'
                                        type='text'
                                        placeholder='Phone No'
                                        value={formValue?.ContactNo}
                                        maxLength={12}
                                        onChange={(e: any) => handleChange('ContactNo', onlyNumeric(e?.target?.value))}
                                    />
                                    {formErrors?.ContactNo && <div className='text-danger text-start fs_14'>{formErrors?.ContactNo}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='create_query_subheader py-2 mt-2'>
                    <h5 className='mb-0 text-center'>Trip Details</h5>
                </div>
                <div className=' mt-2 p-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='OriginCityName' className='form-label'>Origin City</label>
                                </div>
                                <div className='col-8'>
                                    <Select
                                        id='OriginCityName'
                                        name='OriginCityName'
                                        className='dropdown select_dropdown custom_class'
                                        options={location?.state?.dropdownList?.cityList}
                                        value={location?.state?.dropdownList?.cityList?.filter((fil: any) => formValue?.OriginCityId === fil?.value)}
                                        isSearchable={true}
                                        closeMenuOnSelect={true}
                                        placeholder='Select'
                                        onChange={(e: any) => hendeldropdown('OriginCityName', e)}
                                        isClearable
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-4 mb-1'>
                                    <label className="form-label">No. Of traveler</label>
                                </div>
                                <div className='col-8 mb-1'>
                                    <Select
                                        id='genderid'
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: 'white',
                                                primary50: 'white',
                                            },
                                        })}
                                        className="dropdown select_dropdown custom_class increment_select"
                                        options={val}
                                        value={val?.filter(function (val: any) {
                                            return val.value === 0;
                                        })}
                                        closeMenuOnSelect={false}
                                        placeholder={<>
                                            <span className='me-1'>Adult</span>
                                            <span className='me-1'>({formValue?.Adult}),</span>
                                            <span className='me-1'>Child</span>
                                            <span className='me-1'>({formValue?.Child}),</span>
                                            <span className='me-1'>Infant</span>
                                            <span className='me-1'>({formValue?.Infant})</span>
                                        </>}
                                        isSearchable={false}
                                    // onChange={handleGenderChange}
                                    // isDisabled={disabled}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-4 mb-1'>
                                    <label className="form-label">Travel Date</label>
                                </div>
                                <div className='col-8 mb-1'>
                                    <DatePicker
                                        name='TravelDate'
                                        className='form-control antd_date_picker'
                                        placeholder='Travel Date'
                                        minDate={dayjs(new Date())}
                                        format={'DD-MM-YYYY'}
                                        onChange={(e: any) => handleChange("TravelDate", e?.$d ? formatDate(e?.$d) + 'T00:00:00' : null)}
                                        value={formValue?.TravelDate !== null ? dayjs(new Date(formValue?.TravelDate)) : null}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='PackageName' className='form-label'>Package Name/ID</label>
                                </div>
                                <div className='col-8'>
                                    <Select
                                        id='PackageName'
                                        name='PackageName'
                                        className='dropdown select_dropdown custom_class'
                                        options={location?.state?.dropdownList?.packageList}
                                        value={location?.state?.dropdownList?.packageList?.filter((fil: any) => formValue?.PackageId === fil?.value)}
                                        isSearchable={true}
                                        closeMenuOnSelect={true}
                                        placeholder='Select'
                                        onChange={(e: any) => hendeldropdown('PackageName', e)}
                                        isClearable
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='create_query_subheader py-2 mt-2'>
                    <h5 className='mb-0 text-center'>Query Description</h5>
                </div>
                <div className=' mt-2 p-2'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-2 mb-1'>
                                    <label className="form-label">Query In detail</label>
                                </div>
                                <div className='col-10 mb-1'>
                                    <textarea
                                        rows={3}
                                        name='QueryDetails'
                                        className="form-control"
                                        placeholder="Query In detail"
                                        maxLength={1500}
                                        onChange={(e: any) => handleChange('QueryDetails', e?.target?.value)}
                                        value={formValue?.QueryDetails}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateQuery